import { TRoleAccess } from '@/constant/storage';
import { generatePathname } from '@/helpers/generatePathname';
import { PATH_NAME } from 'configs/pathName';
import {
  EPostType,
  INewPostDetailBE,
  IPost,
  IPostBE,
} from '../../interfaces/post.interface';
import { FolderStatusEnum } from '../../interfaces/training.interface';
/**
  this function is use for convert object have interface is IPostBE to object have interface is IPost
 */
export function convertToIPost(data: IPostBE): IPost {
  return {
    group: data.folder && {
      name: data.folder.name,
      avatar: data.folder.avatar,
      userRole: data.folder.userRole as TRoleAccess,
      groupId: data.folder.id,
      status: data.folder.status as FolderStatusEnum,
      slug: generatePathname({
        pathname: PATH_NAME.MY_GROUPS_DETAIL,
        query: {
          gid: data.folder.id,
        },
      }),
    },
    owner: {
      avatar: data.owner.avatar || null,
      name: data.owner.fullName,
      academicRank: data.owner.academicRank || null,
      userId: data.owner.ownerId.toString() || '',
      slug: data.owner.slug
        ? `/${data.owner.slug}`
        : generatePathname({
            pathname: PATH_NAME.PROFILE,
            query: {
              uid: data.owner?.ownerId?.toString(),
            },
          }),
      hasBlueTick: data.owner.hasBlueTick || null,
    },
    createdAt: data.createdOn,
    isOwner: data.isAuthorPost,
    hashTags:
      (data?.hashtags || [])
        .filter((item) => !item.isDefault)
        .map((item) => ({
          name: item.name,
          id: item.id,
        })) ?? [],
    title: data.title,
    content: data.content,
    postId: data.id,
    react: data.votes,
    isReact: data.postVoted.isVoted,
    images: (data?.postImages || []).map((item) => item.url) ?? [],
    sharesCount: data.shareCount,
    type: data.type as EPostType,
    commentCount: data.commentCount,
    isRecruitExpired: data.isRecruitExpired,
    isRecruitStarted: data.isRecruitStarted,
    lastSubmittedAt: data.lastSubmittedAt,
    startDate: data.startDate,
    endDate: data.endDate,
    allowUploadedFile: data.allowUploadedFile,
  };
}

export const newDetailBEPostConvertToIPost = (
  data: INewPostDetailBE
): IPost => {
  return {
    group: data.group && {
      ...data.group,
      groupId: data.group.id,
      status: data.group.status as FolderStatusEnum,
      userRole: data.group.userRole as TRoleAccess,
    },
    owner: {
      avatar: data.author.avatar,
      name: data.author.fullName,
      academicRank: data.author.academicRank,
      userId: data.author.id,
      slug: data.author.slug,
      hasBlueTick: data.author.isVerified,
    },
    createdAt: data.createdOn,
    isOwner: data.isAuthor,
    hashTags: (data.hashTags || []).map((item) => ({
      name: item.name,
      id: item.id,
    })),
    title: data.title,
    content: data.content,
    postId: data.id,
    react: data.totalVote,
    isReact: data.isVoted,
    images: data?.images || [],
    sharesCount: data.totalShare,
    type: data.type as EPostType,
    commentCount: data.totalComment,
    isRecruitExpired: data.hasEnded,
    isRecruitStarted: data.hasStarted,
    lastSubmittedAt: data.lastSubmittedAt,
    startDate: data.startOn,
    endDate: data.endOn,
    allowUploadedFile: data.canUploadFiles,
    readingTime: data.readingTime,
  };
};
